import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useWebServer } from "../../../../../providers";
import {
  displayErrorNotification,
  displaySuccessNotification,
} from "../../../../../actions/notifications";

const REPORT_SETTINGS = "/organization/report-settings";

// The organization's first day of the week for weekly reports
// (GET/PATCH /organization/report-settings). Shared by everyone in it.
const WeekStartSetting = ({ displayErrorNotification, displaySuccessNotification }) => {
  const { sendOrganizationRequest } = useWebServer();
  const [weekStart, setWeekStart] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let current = true;
    sendOrganizationRequest("get")({ url: REPORT_SETTINGS })
      .then((res) => current && setWeekStart(res?.data?.weekStart ?? "monday"))
      .catch(() => current && setWeekStart("monday"));
    return () => {
      current = false;
    };
    // Once, on mount: the provider builds a new sendOrganizationRequest
    // whenever it renders, and refetching then would throw away a choice
    // still being saved.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async (_, next) => {
    if (!next || next === weekStart) return;
    const previous = weekStart;
    setWeekStart(next);
    setSaving(true);
    try {
      await sendOrganizationRequest("patch")({ url: REPORT_SETTINGS, data: { weekStart: next } });
      displaySuccessNotification(`Weekly reports now start weeks on ${next === "monday" ? "Monday" : "Sunday"}`);
    } catch (err) {
      setWeekStart(previous);
      displayErrorNotification(err?.response?.data?.error || "The week start could not be saved");
    } finally {
      setSaving(false);
    }
  };

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      color="primary"
      value={weekStart}
      onChange={save}
      disabled={weekStart == null || saving}
      aria-label="Weeks start on"
    >
      <ToggleButton value="monday">Monday</ToggleButton>
      <ToggleButton value="sunday">Sunday</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default connect(null, { displayErrorNotification, displaySuccessNotification })(WeekStartSetting);
